/* Quiesco — de stoffenkaart op de stoelpagina's weer laten uitklappen.

   In de productbeschrijving staat per stof een <button class="accordion1">
   met daaronder een <div class="panel">. Het oude Debut-thema had JavaScript
   dat die panelen open- en dichtklapte; dat is bij de overstap verdwenen,
   waardoor veertien stoffen tegelijk openstonden.

   Dit script maakt er weer uitklappers van. Doet het script het niet, dan
   blijven de panelen gewoon zichtbaar: er gaat dus nooit inhoud verloren. */

(function () {
  'use strict';

  function init(root) {
    var buttons = root.querySelectorAll('button.accordion1');
    if (!buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      bind(buttons[i]);
    }
  }

  function bind(button) {
    var panel = button.nextElementSibling;
    while (panel && panel.className.indexOf('panel') === -1) {
      panel = panel.nextElementSibling;
    }
    if (!panel) return;

    // Zonder type="button" verstuurt een knop in een formulier de pagina.
    button.setAttribute('type', 'button');
    button.setAttribute('aria-expanded', 'false');
    panel.hidden = true;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  }

  function run() {
    var roots = document.querySelectorAll('.qstory');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
